import React from "react";
import {
    SortingState,
    IntegratedSorting,
    PagingState,
    CustomPaging
} from '@devexpress/dx-react-grid';
import {
    Grid,
    Table as Table2,
    TableHeaderRow,
    Toolbar as Toolbar2,
    PagingPanel
} from '@devexpress/dx-react-grid-material-ui';
import PropTypes from 'prop-types';
import CustomPagingPanel from '../../common/data-table/CustomPagingPanel';

const getColumns = (rows) => {
    return Object.keys(rows[0]).map(key => {
        return { name: key, title: key }
    });
};

const DrillDownDataTable = (props) => {
    const { rows, changeCurrentPage, changePageSize, athenaQuery } = props;

    return (
        <Grid
            rows={rows}
            columns={getColumns(rows)}
        >
            <PagingState
                currentPage={athenaQuery.offset}
                onCurrentPageChange={changeCurrentPage}
                onPageSizeChange={changePageSize}
                pageSize={athenaQuery.limit}
            />
            <SortingState
            />
            <IntegratedSorting />
            <Table2 />
            <CustomPaging
                totalCount={athenaQuery.totalElements}
            />
            <TableHeaderRow showSortingControls />
            <PagingPanel
                containerComponent={() => <CustomPagingPanel
                    pageSizes={[20, 100, 500, 1000]}
                    pageSize={athenaQuery.limit}
                    onChangePageSize={changePageSize}
                    currentPage={athenaQuery.offset}
                    totalCount={athenaQuery.totalElements}
                    onCurrentPageChange={changeCurrentPage}
                />}
            />
        </Grid>
    )
}

DrillDownDataTable.propTypes = {
    rows: PropTypes.array,
    changeCurrentPage: PropTypes.func,
    changePageSize: PropTypes.func,
    athenaQuery: PropTypes.object
}

export default DrillDownDataTable;



// WEBPACK FOOTER //
// ./src/main/content/query/tables/DrillDownDataTable.js